require('../modules/es6.symbol');
require('../modules/es6.object.to-string');
module.exports = require('../modules/_core').Symbol;



//////////////////
// WEBPACK FOOTER
// C:/dev/um.stamps/node_modules/core-js/es6/symbol.js
// module id = ../../../../core-js/es6/symbol.js
// module chunks = vendor